/* eslint-disable react/forbid-component-props */
import React from 'react';
import Checkbox from '@adsk/alloy-react-checkbox';
import FormField from '@adsk/alloy-react-form-field';
import { useLocale } from '@adsk/alloy-react-helpers';
import { useStore } from '@common/StoreProvider';
import { ACCOUNT_USER_ACESSES } from '../../constants';
import { ACTIONS } from '../../state/actions';
import {
  accessDescriptionText,
  accessOptionDescription,
  accessOptionTitle,
  checkboxStyle,
  containerStyle,
  optionStyle,
} from './styles';

const AccountAccessLevels = () => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const { state, dispatch } = useStore();

  const handleMemberAccessChange = (accessLevels) => {
    const { accessName, value } = accessLevels;
    const newAccessLevels = {
      ...state.selectedAccountAccessLevels,
      [accessName]: value,
    };

    dispatch({
      type: ACTIONS.SET_ACCOUNT_ACCESS_LEVEL,
      payload: newAccessLevels,
    });
  };

  return (
    <FormField
      label={T.translate('ACCESS_LEVEL')}
      labelVariant={FormField.LABEL_VARIANTS.TOP}
      style={{ paddingTop: '20px' }}
      data-testid="InviteAccountMemberModal_account_access_field"
    >
      <div css={containerStyle}>
        <div css={accessDescriptionText}>
          {T.translate('ORGANIZATION_DESCRIPTION')}
        </div>
        <div css={optionStyle}>
          <Checkbox
            data-testid="InviteAccountMemberModal_account_access_field_org_admin"
            checked={
              state.selectedAccountAccessLevels[ACCOUNT_USER_ACESSES.ADMIN]
            }
            css={checkboxStyle}
            onChange={(value) =>
              handleMemberAccessChange({
                accessName: ACCOUNT_USER_ACESSES.ADMIN,
                value,
              })
            }
          />
          <div>
            <div css={accessOptionTitle}>
              {T.translate('ORGANIZATION_ADMIN')}
            </div>
            <div css={accessOptionDescription}>
              {T.translate('ORGANIZATION_ADMIN_DESCRIPTION')}
            </div>
          </div>
        </div>
        <div css={optionStyle}>
          <Checkbox
            data-testid="InviteAccountMemberModal_account_access_field_org_executive"
            checked={
              state.selectedAccountAccessLevels[ACCOUNT_USER_ACESSES.EXECUTIVE]
            }
            css={checkboxStyle}
            onChange={(value) =>
              handleMemberAccessChange({
                accessName: ACCOUNT_USER_ACESSES.EXECUTIVE,
                value,
              })
            }
          />
          <div>
            <div css={accessOptionTitle}>
              {T.translate('ORGANIZATION_EXECUTIVE')}
            </div>
            <div css={accessOptionDescription}>
              {T.translate('ORGANIZATION_EXECUTIVE_DESCRIPTION')}
            </div>
          </div>
        </div>
      </div>
    </FormField>
  );
};

export default AccountAccessLevels;
